import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {IUser} from '../../../../commons/interfaces/user/user';

interface IEsportazioneArchivioPretdoc {
  piva: string;
  docClass: string;
}

class EsportazioneArchivioPretdocController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$uibModal',
    '$state'
  ];

  constructor(
    private $scope: {
      // puoi definire il tipo di scope, aiuta il compilatore dopo con le varie proprieta
      data: IEsportazioneArchivioPretdoc,
      docsClassUser: string [],
      user: IUser,
      // questo serve per evitare errori di typescript su parametri non definiti, di default ogni parametro è any
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: any,
  ) {
    $scope.PIVAType = new RegExp('^[0-9]{11}$');
    $scope.pageHeader = 'Esportazione Archivio PretDoc';

    $scope.getDocClass = (piva: string) => {
      ArchiSmallServices.getUserByPiva(piva).then((response) => {
        $scope.user = JSON.parse(JSON.stringify(response)) as IUser;
        let MapDocsClassUser = $scope.user.classiDocumentali;
        $scope.docsClassUser = Object.entries(MapDocsClassUser)
          .filter(([key, value]) => value === true)
          .map(([key, value]) => key.toUpperCase())
          .sort((a, b) => a.localeCompare(b));
      }).catch((error) => {
        $scope.docsClassUser = [];
        console.error(error);
      });
    };

    $scope.exportArchivePreTdoc = (data: IEsportazioneArchivioPretdoc) => {
      let CreateModal = $uibModal.open({
        animation: true,
        component: 'workerExportArchivePreTdocModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return {
              username: $scope.user.accountData.email,
              docClass: data.docClass
            };
          }
        }
      });
      CreateModal.result.catch(error => {
        console.error('Error:', error);
      })
        .finally(() => {
          $state.reload();
        });
    };
  }
}


export const EsportazioneArchivioPretdocComponent: ng.IComponentOptions = {
  template: require('./esportazione-archivio-pretdoc.html'),
  controller: EsportazioneArchivioPretdocController
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/esportazione-archivio-pretdoc/esportazione-archivio-pretdoc.ts